<template>
  <div>
    <h2>HeartBeatFam Family Game Nights</h2>
    <div id="debugElement"> </div>
    <h6>Memory Match</h6>
    <h6>Gone Fishing</h6>
    <h6>Bubble Pop</h6>

    <h6>
      Show Animation of Game -- and "Good Job, Good Job"
      Show Box for Input to connect
      Poll Connection

    </h6>
  </div>
</template>

<script>


export default {
  name: "Signup",
  components: {

  },
  mounted(){
    debugger;

  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.signup {
  min-height: 100vh;
}
</style>
